/**
 * Converts the limited markdown subset used in policy texts to HTML.
 *
 * Supported syntax:
 *   #### Title       → stripped (section head already renders the title)
 *   ###### Heading   → <h6>
 *   - item           → <ul><li>
 *   **bold**         → <strong>
 *   ==value==        → <mark>
 */
export function parsePolicyMarkdown(text: string): string {
  // Strip the leading #### title — it duplicates the section head rendered separately
  const stripped = text.replace(/^####[^\n]*\n*/, '')

  const lines = stripped.split('\n')
  const result: string[] = []
  let inList = false

  const inline = (s: string) =>
    s.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>').replace(/==(.+?)==/g, '<mark>$1</mark>')

  for (const line of lines) {
    const trimmed = line.trim()

    if (trimmed.startsWith('###### ')) {
      if (inList) {
        result.push('</ul>')
        inList = false
      }

      result.push(`<h6>${inline(trimmed.slice(7))}</h6>`)
    } else if (/^[-*]\s+/.test(trimmed)) {
      if (!inList) {
        result.push('<ul>')
        inList = true
      }

      result.push(`<li>${inline(trimmed.replace(/^[-*]\s+/, ''))}</li>`)
    } else if (trimmed === '') {
      if (inList) {
        result.push('</ul>')
        inList = false
      }
    } else {
      if (inList) {
        result.push('</ul>')
        inList = false
      }

      result.push(`<p>${inline(trimmed)}</p>`)
    }
  }

  if (inList) {
    result.push('</ul>')
  }

  return result.join('')
}
